export const environment = {
  production: true,
  server_url:"https://services.azre.gov/OlsWebApi",
  changeEmployerReceiptPageReturnUrl: window.location.origin + "/dre/#/receiptChangeEmployer",
  severEmploymentReceiptPageReturnUrl: window.location.origin + "/dre/#/severEmploymentReceipt",
  renewalReceiptPageReturnUrl: window.location.origin + "/dre/#/renewalReceipt" 
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts